import {Component} from 'react';
import { connect } from "react-redux";
import { Button } from 'react-bootstrap'

import translations from "../../../config/translation/login_translations.json"

const mapStateToProps = state => {
	return {	
		language: state.languageReducer ? state.languageReducer : 'ENGLISH'
	};
}

class PrimaryButton extends Component {
   render() {
      if (this.props.buttonLabel !== undefined) {
         return <Button variant="primary" type="submit" disabled={this.props.disabled}>{this.props.buttonLabel}</Button>
      }
      return (
         <Button variant="primary" type="submit" disabled={this.props.disabled}>{translations[this.props.language].submit}</Button>
      )
   }
}

export default connect(mapStateToProps)(PrimaryButton);